import TypeOfInstalationExternalDoorReplacement from './TypeOfInstalationExternalDoorReplacement';

export default TypeOfInstalationExternalDoorReplacement;